import { useState, useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CultureSlider from './components/CultureSlider';
import { adminStore } from '../../store/adminStore';

export default function Home() {
  const [homeContent, setHomeContent] = useState(() => adminStore.getStore().home);

  useEffect(() => {
    const handler = () => setHomeContent(adminStore.getStore().home);
    window.addEventListener('bahnar-admin-updated', handler);
    return () => window.removeEventListener('bahnar-admin-updated', handler);
  }, []);

  return (
    <div className="min-h-screen bg-primary-cream">
      <Header />
      <section className="relative pt-32 pb-24 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Traditional%20Bahnar%20ethnic%20village%20highlands%20Vietnam%2C%20wooden%20stilt%20houses%2C%20lush%20tropical%20greenery%2C%20misty%20mountains%20in%20background%2C%20warm%20golden%20sunrise%20light%2C%20soft%20watercolor%20painterly%20style%2C%20cultural%20heritage%20landscape%2C%20serene%20atmosphere%2C%20earthy%20orange%20brown%20tones&width=1400&height=600&seq=home-hero-bg&orientation=landscape"
            alt=""
            className="w-full h-full object-cover object-top"
            style={{ filter: 'blur(5px) brightness(0.45)', transform: 'scale(1.06)' }}
          />
        </div>

        <div className="relative max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="space-y-8">
              <h1
                className="text-5xl font-extrabold text-white leading-tight whitespace-pre-line"
                style={{ textShadow: '0 2px 6px rgba(0,0,0,0.55), 0 6px 24px rgba(0,0,0,0.45), 0 0 40px rgba(180,80,0,0.3)', letterSpacing: '-0.5px' }}
              >
                {homeContent.heroTitle}
              </h1>
              <p
                className="text-xl text-white/85 leading-relaxed"
                style={{ textShadow: '0 1px 8px rgba(0,0,0,0.45)' }}
              >
                {homeContent.heroDescription}
              </p>
            </div>

            <div className="relative">
              <img
                src="https://static.readdy.ai/image/1cc4dff2fab325f8b161c01cf2cdaccb/aeb0ac9e41231fa4c66e0bf30e5d5da7.png"
                alt="Trẻ em chơi trò dân gian Bahnar"
                className="w-full h-auto rounded-3xl"
              />
              <div className="absolute -top-4 -right-4 w-20 h-20 bg-primary-yellow/90 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-music-2-fill text-3xl text-white"></i>
              </div>
              <div className="absolute bottom-8 -left-4 w-24 h-24 bg-primary-orange/90 rounded-full flex items-center justify-center shadow-lg">
                <i className="ri-home-smile-fill text-4xl text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      <CultureSlider />

      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="inline-flex items-center gap-3 mb-6">
            <div className="w-8 h-8 flex items-center justify-center bg-primary-yellow rounded-full">
              <i className="ri-seedling-fill text-lg text-white"></i>
            </div>
          </div>
          <p className="text-2xl text-primary-brown leading-loose">
            {homeContent.introText}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}
